import { Link } from '@cian/link-component';
import * as React from 'react';
import { ICountrysideBuilderLandingPromoVillageData } from '../../types';
import { getUTMDataForLink } from '../../utils/getUTMDataForLink';
import { mergeUrlWithAdditionalQuery } from '../../utils/mergeUrlWithAdditionalQuery';
import { trackTrapLinkClick } from '../../utils/tracking/trackTrapLinkClick';
import { BuilderVillage } from '../Icons';
import * as styles from './AsideTipCountrysideBuilderPromo.css';

export interface IAsideTipCountrysideBuilderPromoProps {
  data: ICountrysideBuilderLandingPromoVillageData | null;
  offerId: number;
}

export function AsideTipCountrysideBuilderPromo({ data, offerId }: IAsideTipCountrysideBuilderPromoProps) {
  if (!data || !data.bannerLink || data.bannerType !== 'banner2') {
    return null;
  }

  const utm = getUTMDataForLink('banner2', offerId);

  return (
    <div className={styles['container']}>
      <div className={styles['main']}>
        <p className={styles['description']}>Сколько стоит построить здесь дом?</p>
        <Link
          className={styles['link']}
          href={mergeUrlWithAdditionalQuery(data.bannerLink, utm)}
          target="_blank"
          rel="nofollow noopener"
          onClick={() => trackTrapLinkClick(offerId)}
        >
          Узнать стоимость
        </Link>
      </div>
      <div className={styles['icon_wrapper']}>
        <BuilderVillage />
      </div>
    </div>
  );
}
